// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__2b3-C","card":"Cards_card__3xK-C","infected":"Cards_infected__3xP-9","recovered":"Cards_recovered__3gP_W","deaths":"Cards_deaths__2NC5m"};